import React from "react";
import styled from "styled-components";
import { Asset } from "src/types";
import { AssetCard } from "../AssetCard";

export interface AssetsListProps {
  data: Asset[];
  onAssetClick: (asset: Asset) => void;
}

export const AssetsList = ({ data, onAssetClick }: AssetsListProps) => {
  return (
    <Container>
      {data.map((asset: Asset) => (
        <AssetCardContainer key={asset.id}>
          <AssetCard asset={asset} onClick={() => onAssetClick(asset)} />
        </AssetCardContainer>
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding: 16px;
`;

const AssetCardContainer = styled.div`
  margin-bottom: 10px;
`;
